<template>
  <div class="pagination-container">
    <div class="pageRange">
      <strong>{{ firstItem + 1 }}</strong> -
      <strong>{{ lastItem > filteredArray.length ? filteredArray.length : lastItem }}</strong> de
      <strong>{{ filteredArray.length }}</strong>
    </div>
    <div v-if="this.pages.length > 1" class="navigation">
      <div class="button-pagination" @click="navigate('prev')">◀</div>
      <div>
        <b>{{ selectedPage }}</b>
      </div>
      <div class="button-pagination" @click="navigate('next')">▶</div>
    </div>
    <div v-if="this.pages.length > 1" class="pagination">
      <button v-if="!almostFirstPage" @click="handleSelectedPage(pages[0])" class="pageNumber">
        {{ pages[0] }}
      </button>
      <span v-if="!almostFirstPage && pages.length > 3">...</span>
      <button
        v-for="page in visiblePages"
        :disabled="selectedPage == page ? true : false"
        :id="page"
        class="pageNumber"
        @click="handleSelectedPage(page)"
      >
        {{ page }}
      </button>
      <span v-if="!almostLastPage && pages.length > 3">...</span>
      <button v-if="!almostLastPage" class="pageNumber" @click="handleSelectedPage(pages.length)">
        {{ pages.length }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",

  props: {
    filteredArray: Array,
    firstItem: Number,
    lastItem: Number
  },

  data() {
    return {
      selectedPage: 1
    };
  },

  created() {
    this.handleSelectedPage(1);
  },

  computed: {
    pages: function() {
      let pages = [];
      let pageNumber = 0;

      for (var i = 0; i <= this.filteredArray.length; i = i + 10) {
        pageNumber = pageNumber + 1;
        pages.push(pageNumber);
      }

      this.selectedPage = 1;
      return pages;
    },
    visiblePages: function() {
      let visiblePages = [];
      if (this.selectedPage == 1) {
        visiblePages = this.pages.slice(0, this.selectedPage + 2);
      } else if (this.selectedPage == this.pages.length) {
        visiblePages = this.pages.slice(this.pages.length - 3, this.selectedPage);
      } else {
        visiblePages = this.pages.slice(this.selectedPage - 2, this.selectedPage + 1);
      }

      return visiblePages;
    },
    disabledCheck: function() {
      const element = document.getElementsByClassName("pageNumber");

      if (element.disabled) {
        return true;
      }
      return false;
    },
    almostLastPage: function() {
      let isNear = this.visiblePages.find(page => page == this.pages.length);
      if (isNear) {
        return true;
      }

      return false;
    },
    almostFirstPage: function() {
      let isNear = this.visiblePages.find(page => page == this.pages[0]);
      if (isNear) {
        return true;
      }

      return false;
    }
  },

  methods: {
    handleSelectedPage: function(page) {
      this.selectedPage = page;

      this.$emit("selectedPage", this.selectedPage);
    },
    navigate(direction) {
      if (direction == "next") {
        if (this.selectedPage == this.pages.length) {
          this.handleSelectedPage(1);
        } else {
          this.handleSelectedPage(this.selectedPage + 1);
        }
      }
      if (direction == "prev") {
        if (this.selectedPage == 1) {
          this.handleSelectedPage(this.pages.length);
        } else {
          this.handleSelectedPage(this.selectedPage - 1);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 12px;
}

.pageNumber {
  margin-left: 4px;
}

button:disabled {
  font-weight: bold;
}
.navigation {
  display: flex;
  cursor: pointer;
  user-select: none;
  div {
    width: 20px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.pageRange {
  width: 100px;
}
.pagination {
  min-width: 100px;
  display: flex;
  justify-content: flex-end;
}
.button-pagination {
  color: var(--azul2);
  transition: filter 0.5s ease;
  &:hover {
    filter: brightness(0.8);
  }
}
</style>
